import React from 'react';
import cx from 'classnames';
import { IconButton } from '@material-ui/core';

import TextLink from 'src/components/TextLink';
import { CustomTypography } from 'src/components/CustomTypography';
import { CustomButton } from 'src/components/CustomButton';
import { IconCloseThin } from 'src/assets/icons/CloseThin';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';
import svg from './icon.svg';

const LINK =
  'https://anyword.zoom.us/webinar/register/4717176802217/WN_6lSA4u_DSASLbLr37ahrEw#/registration';

export const WebinarBanner = ({ className }) => {
  const styles = useStyles();

  const { handleClose } = useHandlers();

  return (
    <a
      className={cx(styles.root, className)}
      href={LINK}
    >
      <CustomTypography className={styles.liveWebinar}>
        <img
          src={svg}
          alt=""
        />
        Live Webinar
      </CustomTypography>
      <TextLink
        className={styles.title}
        href={LINK}
        target="_blank"
        rel="noopener"
      >
        How Real Marketing Teams Use AI | Anyword with Blazeo |{' '}
        <span className={styles.time}>Wed, Jun 26, at 1:30 pm EST</span>
      </TextLink>
      <CustomButton
        href={LINK}
        className={styles.button}
      >
        Save your spot
      </CustomButton>
      <IconButton
        onClick={handleClose}
        className={styles.closeButton}
      >
        <IconCloseThin className={styles.closeIcon} />
      </IconButton>
    </a>
  );
};
